<nouislider *ifSsr="ssr"
            [min]="min"
            [max]="max"
            [formControl]="control"
            [connect]="connect"
            [step]="step"
            [tooltips]="tooltips"
            [limit]="limit"
            [animate]="animate"
            [config]="{
                direction: direction,
                padding: padding,
                margin: margin,
                documentElement: document
            }"
            (change)="valueChanges.emit($event)"
            [class.show-tooltip-on-focus]="! showTooltip"
></nouislider>

<ng-template #ssr>
    <input type="number"
           [min]="min"
           [max]="max"
           [step]="step"
    />
</ng-template>
